import { ComponentChildren, toChildArray } from 'preact';

type StackDirection = 'horizontal' | 'vertical';

const row = {
  display: 'flex',
  'flex-direction': 'row',
  'flex-wrap': 'wrap',
};

const col = {
  'flex-basis': '100%',
  flex: 1,
};

const childSpacing = {
  'none': {},
  'normal': {
    padding: '4px 2px 4px 2px',
  },
};

type GridModel = {
  children: ComponentChildren;
  direction: StackDirection;
  spacing?: 'none' | 'normal';
  collapse?: boolean;
  childClass?: string;
  class?:string;
};

export const Grid = ({ children, direction, collapse, spacing, childClass, class: cssClass}: GridModel) => {
  const containerStyle = direction == 'horizontal' ? row : {};
  let childWrapperStyle = direction == 'horizontal' ? (collapse ? {} : col) : {};

  childWrapperStyle = { ...childWrapperStyle, ...childSpacing[spacing ?? 'none'] };

  return (
    <section style={containerStyle} class={cssClass}>
      {toChildArray(children).map((child) => (
        <div style={childWrapperStyle} class={childClass}>
          {child}
        </div>
      ))}
    </section>
  );
};
